import { Link } from 'react-router-dom'
import { useContacto } from '../data/contacto'
import './Carta.css'

export function MenuDelDia({ precio = '13,00 €' }) {
  const fecha = new Date().toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric', month: 'long' })
  const fechaCapitalizada = fecha.charAt(0).toUpperCase() + fecha.slice(1)
  return (
    <div className="menu-dia-card">
      <div className="menu-dia-header">
        <div className="menu-dia-titulo">MENÚ DEL DÍA</div>
        <div className="menu-dia-precio">{precio}</div>
      </div>
      <div className="menu-dia-fecha">{fechaCapitalizada}</div>
      <div className="menu-dia-linea" />
      <div className="menu-dia-fila menu-dia-fila--normal">Ensalada mixta</div>
      <div className="menu-dia-linea" />
      <div className="menu-dia-fila menu-dia-fila--elegir">
        <span>Primer plato</span>
        <span className="menu-dia-elegir-tag">a elegir</span>
      </div>
      <div className="menu-dia-linea" />
      <div className="menu-dia-fila menu-dia-fila--elegir">
        <span>Segundo plato</span>
        <span className="menu-dia-elegir-tag">a elegir</span>
      </div>
      <div className="menu-dia-linea" />
      <div className="menu-dia-fila menu-dia-fila--elegir">
        <span>Postre</span>
        <span className="menu-dia-elegir-tag">a elegir</span>
      </div>
      <div className="menu-dia-linea" />
      <div className="menu-dia-footer">
        Incluye <strong>bebida</strong> y <strong>café</strong>
      </div>
    </div>
  )
}

export default function Carta() {
  const c = useContacto()
  return (
    <div className="page carta-page">
      <div className="page-header">
        <p className="page-label">Gastronomía</p>
        <h1 className="page-title">Menú del día</h1>
        <div className="page-divider"></div>
        <p className="carta-intro">Cocina casera con productos locales y de temporada. Consulta con nuestro personal sobre alérgenos.</p>
      </div>

      <MenuDelDia precio={c.menu_dia_precio} />

      <div className="carta-aviso">
        <Link to="/alergenos" style={{ color: 'var(--gold)', fontSize: '0.75rem', letterSpacing: '0.15em', textTransform: 'uppercase', textDecoration: 'none' }}>
          Ver información completa de alérgenos →
        </Link>
      </div>
    </div>
  )
}
